import Loading from "component/Loading";
import Modal from "component/Modal";
import { useLoginInfo } from "hook/loginInfo";
import MicroModal from "micromodal";
import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { api_commonFetch } from "util";

export default function Home(){
    return (
        <Suspense fallback={<Loading/>}>
            <App/>
        </Suspense>
    );
}

export function App(){

    const navigate = useNavigate();
    const date = new Date();
    const [params, setParams] = useSearchParams();
    const [vo, setVO] = useState({
        searchStartDate : params.get('searchStartDate') || date.getFullYear() + "-01-01"
        , searchEndDate : params.get('searchEndDate') || date.getFullYear() + "-12-31"
    });
    const [loading, setLoading] = useState(true);
    const loginInfo = useLoginInfo();

    const fn_search = ()=>{
        const form = document.searchForm;
        const tmp ={
            ...vo
            , searchStartDate : form.searchStartDate.value
            , searchEndDate : form.searchEndDate.value
        }
        setVO(tmp);
        navigate('/diary?' + new URLSearchParams(tmp));
    }

    const [bodyList, setBodyList] = useState([]);

    const fn_getBodyList = async()=>{
        setLoading(true);

        const url = process.env.REACT_APP_API_URL + '/bodyList?' + new URLSearchParams(vo);
        const config = {method : 'get', headers : {Authorization : "Bearer " + sessionStorage.getItem('accessToken')}}
        const data = await api_commonFetch(url, config);
        setBodyList(data.bodyList);
        setLoading(false);
    }

    const fn_insert = ()=>{
            const form = document.postForm;
            form.no.value = '';
            form.startDate.value = new Date(date.getTime() + (9 * 60 * 60 * 1000)).toISOString().split("T")[0];
            form.bs.value = '0';
            form.bp.value = '';
            form.actList.value = '';
            MicroModal.show("modal");
        }
    
        const fn_update = (ob)=>{
            const form = document.postForm;
            form.no.value = ob.no;
            form.startDate.value = ob.startDate;
            form.bs.value = ob.bs;
            form.bp.value = ob.bp;
            form.actList.value = ob.actList;
            MicroModal.show("modal");
        }
    
        const fn_postForm = async ()=>{
            const form = document.postForm;
            const formData = new FormData(form);
            const config = {method : 'post', body : formData, headers : {Authorization : "Bearer " + sessionStorage.getItem('accessToken')}};
            let url = '';
            let msg = '';
    
            if(form.no.value == ''){
                url = process.env.REACT_APP_API_URL + '/bodyInsertAction';
                msg = '등록하시겠습니까?'
            }else{
                url = process.env.REACT_APP_API_URL + '/bodyUpdateAction';
                msg = '수정하시겠습니까?';
            }
    
            await Swal.fire({
                title: msg
                , showCancelButton: true
                , confirmButtonText: "확인"
                , cancelButtonText: `취소`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "처리중입니다.",
                        html: "잠시만 기다려주시기 바랍니다.",
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });
                    
                    const data = await api_commonFetch(url, config);
                    
                    if(data.result>0){
                        await Swal.fire("정상적으로 처리되었습니다.");
                        fn_getBodyList();
                        MicroModal.close('modal');
                    }else{
                        await Swal.fire("처리중 오류가 발생하였습니다.");
                    }
                }
            });
        }

    useEffect(()=>{
        fn_getBodyList();
    }, [vo]);

    return (
        <>
            {loading == true ? <Loading/> : ''}

            <form name="searchForm" onSubmit={(e)=>{fn_search(); e.preventDefault();}} className="search-form">
                <div className="col-6">
                    <input type="date" name="searchStartDate" defaultValue={vo.searchStartDate} onChange={(e)=>{fn_search();}}/>
                </div>
                <div className="col-6">
                    <input type="date" name="searchEndDate" defaultValue={vo.searchStartDate} onChange={(e)=>{fn_search();}}/>
                </div>
            </form>

            <div className="text-right">
                <button className="btn btn-primary" onClick={(e)=>{fn_insert(); e.preventDefault();}}>등록</button>                     
            </div>

            <table className="table list">
                <thead>
                    <tr>
                        <th>번호</th>
                        <th>날짜</th>
                        <th>몸무게</th>
                        <th>예상몸무게</th>
                        <th>혈당</th>
                        <th>혈압</th>
                        <th>비고</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        bodyList!=null && bodyList.length>0? (
                            bodyList.map((ob, i)=>{
                                return (
                                    <tr key={ob.no}>
                                        <td>
                                            {ob.no}
                                        </td>
                                        <td>
                                            <button onClick={(e)=>{fn_update(ob); e.preventDefault();}} className="btn btn-success">{ob.startDate}</button>
                                        </td>
                                        <td>
                                            {ob.weight}
                                        </td>
                                        <td>
                                            {Number(ob.expWeight).toFixed(1)}
                                        </td>
                                        <td>
                                            {ob.bs}
                                        </td>
                                        <td>
                                            {ob.bp}
                                        </td>
                                        <td className="text-left">
                                            <div dangerouslySetInnerHTML={{__html : ob.actList.split("\n").join("<br/>")}}></div>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={99}>데이터가 없습니다.</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>

            <Modal id="modal">
                <form name="postForm" onSubmit={(e)=>{fn_postForm(); e.preventDefault();}}>
                    <input type="hidden" name='no'/>
                    <table className="table">
                        <colgroup>
                            <col style={{width:'25%'}}/>
                            <col style={{width:'75%'}}/>
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>날짜</th>
                                <td className="text-left">
                                    <input type="date" name="startDate"/>
                                </td>
                            </tr>
                            <tr>
                                <th>몸무게</th>
                                <td className="text-left">
                                    <input type="number" name="weight"/>
                                </td>
                            </tr>
                            <tr>
                                <th>혈당</th>
                                <td className="text-left">
                                    <input type="number" name="bs"/>
                                </td>
                            </tr>
                            <tr>
                                <th>혈압</th>
                                <td className="text-left">
                                    <input type="text" name="bp"/>
                                </td>
                            </tr>
                            <tr>
                                <th>비고</th>
                                <td className="text-left">
                                    <textarea name="actList" className="col-12" style={{height:'250px'}}/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="text-center">
                        <button className="btn btn-primary" onClick={(e)=>{
                            fn_postForm();
                        }}>저장</button>
                        <button className="btn btn-list" onClick={(e)=>{
                            e.preventDefault();
                            MicroModal.close("modal");
                        }}>닫기</button>
                    </div>
                </form>
            </Modal>
        </>
    );
}